var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 10C13.2 9.70186 13.0508 9.40373 12.9016 9.25466L7.9772 4.3354C7.52953 3.8882 6.78342 3.8882 6.33575 4.3354C5.88808 4.78261 5.88808 5.52795 6.33575 5.97516L10.3648 10L6.33575 14.0248C5.88808 14.472 5.88808 15.2174 6.33575 15.6646C6.78342 16.1118 7.52953 16.1118 7.9772 15.6646L12.7523 10.8944C13.0508 10.5963 13.2 10.2981 13.2 10Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.97042d765ea63c374ae1b8d8cf417fe7.svg";
export { ForwardRef as ReactComponent };